import React from 'react'
import { Menu, MenuItem } from '@mui/material'

type Props = { anchorEl: HTMLElement | null; actions: { label: string; onClick: () => void }[]; onClose: () => void }

const ActionMenu = ({ anchorEl, actions, onClose }: Props) => (
  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
    {actions.map((action) => (
      <MenuItem
        key={action.label}
        onClick={() => {
          onClose()
          action.onClick()
        }}
      >
        {action.label}
      </MenuItem>
    ))}
  </Menu>
)

export default ActionMenu
